"use client";

import * as React from "react";
import { Sparkles, ShieldCheck, Truck, HeartHandshake } from "lucide-react";
export default function ElPoderDeLasPiedras() {
  const highlights = [{
    icon: ShieldCheck,
    title: "Compra con confianza",
    text: "Piezas seleccionadas con intención y cuidado para acompañar tu espacio, tu energía y tus rituales cotidianos."
  }, {
    icon: Truck,
    title: "Envíos dentro de México",
    text: "Preparamos cada pedido con atención para que tus piezas lleguen en buenas condiciones y con la presencia que merecen."
  }, {
    icon: HeartHandshake,
    title: "Atención cercana",
    text: "Si tienes dudas sobre productos, usos o intención de una pieza, puedes escribirnos y con gusto te orientamos."
  }];
  return <section id="experiencias-de-compra" className="dark bg-background text-foreground relative overflow-hidden py-24 md:py-32">
      <div className="absolute inset-0 overflow-hidden pointer-events-none">
        <div className="absolute -top-[30%] -left-[10%] w-[80vw] h-[80vw] rounded-full bg-primary/10 blur-[120px] animate-[spin_90s_linear_infinite]" />
        <div className="absolute -bottom-[30%] -right-[10%] w-[70vw] h-[70vw] rounded-full bg-chart-2/10 blur-[100px] animate-[spin_70s_linear_infinite_reverse]" />
        <div className="absolute top-[20%] left-[60%] w-[40vw] h-[40vw] rounded-full bg-chart-3/5 blur-[90px] animate-[pulse_10s_ease-in-out_infinite]" />
      </div>

      <div className="container relative z-10 mx-auto px-4">
        <div className="text-center mb-16 md:mb-20 max-w-3xl mx-auto">
          <div className="inline-flex items-center justify-center gap-2 mb-4">
            <Sparkles className="size-5 text-primary/70" />
            <span className="text-sm font-medium tracking-widest uppercase text-primary/80">
              Confianza y cuidado
            </span>
            <Sparkles className="size-5 text-primary/70" />
          </div>

          <h2 className="text-3xl md:text-5xl font-serif font-light tracking-wide text-foreground">
            Experiencias de compra
          </h2>

          <p className="mt-6 text-base md:text-lg text-muted-foreground leading-relaxed">
            En El Atelier de NuNa buscamos que cada compra se sienta clara,
            cuidada y significativa. Más que recibir un objeto, queremos que
            encuentres una pieza que resuene contigo y acompañe tu momento
            presente.
          </p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-3 gap-6 max-w-6xl mx-auto">
          {highlights.map((item, index) => {
          const Icon = item.icon;
          return <div key={index} className="rounded-3xl border border-primary/15 bg-background/50 backdrop-blur-sm p-8 text-center shadow-[0_0_30px_rgba(0,0,0,0.08)]">
                <div className="mx-auto mb-5 flex h-14 w-14 items-center justify-center rounded-full border border-primary/20 bg-primary/5">
                  <Icon className="h-6 w-6 text-primary/80" />
                </div>

                <h3 className="font-serif text-2xl text-foreground mb-3">
                  {item.title}
                </h3>

                <p className="text-sm md:text-base text-muted-foreground leading-relaxed">
                  {item.text}
                </p>
              </div>;
        })}
        </div>
      </div>
    </section>;
}